import { type MutableRefObject, type Ref, type RefObject } from 'react';

type Refs =
	| Ref<HTMLElement | null>
	| RefObject<HTMLElement | null>
	| ((node: HTMLElement | null) => void);

/**
 * rovo-navigation
 * This is a restricted import from design system packages so we need to add it ourselves
 *
 * Assigns the node to all the refs passed in the argument.
 *
 * @param refs: An array of refs (as function or ref object)
 */
export default function mergeRefs(refs: Refs[]) {
	return (value: HTMLElement | null): void => {
		refs.forEach((ref) => {
			if (typeof ref === 'function') {
				ref(value);
			} else if (ref !== null) {
				(ref as MutableRefObject<HTMLElement | null>).current = value;
			}
		});
	};
}
